module.exports = __webpack_public_path__ + "static/media/3_Card_color_horizontal.9e964351.svg";